import Plus from "../atoms/Plus";

const HrPlus = (): JSX.Element => (
  <div className="text-center my-3">
    <Plus size={3} />
  </div>
);

export default HrPlus;
